<template>
    
    <div>
        <el-button type="primary" @click="addAdmin" class="addAdmin">添加管理员</el-button>
        <div class="down">
        <el-table
            :data="roles"
            style="width: 100%;margin-bottom: 20px;"
            ref="roles">
             <el-table-column
                type="index"
                 label="序号"
                min-width="180">
            </el-table-column>
            <el-table-column
            prop="roleId"
            label="ID"
            sortable
            width="180">
            </el-table-column>
            <el-table-column
            prop="roleName"
            label="角色名称"
            sortable
            width="180">
            </el-table-column>
            <el-table-column
            prop="roleRemark"
            label="备注">
            </el-table-column>
             <el-table-column
                prop="roleId"
                label="操作"
                min-width="280">
                 <template slot-scope="scope">
                    <div>
                        <el-button type="primary" @click="editRoles(scope.row)">编辑</el-button>
                        <el-button type="primary" @click="editRoleMenu(scope.row.roleId)">设置权限</el-button>
                    </div>
                    
                </template>
                </el-table-column>
        </el-table>
           
           <!-- <ul class="infinite-list" style="overflow:auto">
                <li v-for="(obj,index) in runLog"  v-bind:key="index" class="infinite-list-item" >{{ obj.body }}</li>
            </ul>-->



<div class="block">
    
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNum"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total,sizes, prev, pager, next,jumper"
      :total="total">
    </el-pagination>
  </div>

        </div>
        <el-dialog
            :title="title"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <span>
                <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="角色名称">
                    <el-input v-model="form.roleName"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.roleRemark"></el-input>
                </el-form-item>

                </el-form>

            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAdminFunct">确 定</el-button>
            </span>
            </el-dialog>

              <el-dialog
            title="绑定权限"
            :visible.sync="centerDialogRoleVisible"
            width="30%"
            center>
            <span>
              <el-tree
                :data="menuList"
                show-checkbox
                node-key="menuId"
                ref="tree"
                label="menuName"
                
        
                :default-expanded-keys="menu"
                :default-checked-keys="menuCheck"
                :props="defaultProps">
                </el-tree>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogRoleVisible = false">取 消</el-button>
                <el-button type="primary" @click="addMenuFunct">确 定</el-button>
            </span>
            </el-dialog>

    </div>

    
</template>
<script>
import {Message} from 'element-ui';
export default {
    
name:"version",
    data(){
        return {
            title:"后台运行日志",
            roles:[],
            menuList:[],
            roleId:0,
            menu:[],
            menuCheck:[],
            condition:true,
            dialogTitle:"",
            addMenu:[],
            addRoleMenu:{},
            centerDialogVisible: false,
            centerDialogVisibleimgSrc:false,
            centerDialogRoleVisible:false,
            pageNum:1,
            totalPage:10,
            pageSize:10,
            defaultProps: {
                children: 'chridens',
                label: 'menuName'
            },
            total:1,
            imgSrc:'',
            form: {
                roleId:0,
                roleName:'',
                roleRemark: ''
            },
            params:{
                pageSize:10,
                pageNum:1
            }
        }
    },
    methods:{
       clickBig(obj){
           this.imgSrc=obj;
           this.centerDialogVisibleimgSrc = true
       },
       editRoles(info){
           this.condition=false
           this.form.roleId=info.roleId
           this.form.roleName=info.roleName
           this.form.roleRemark=info.roleRemark
           this.centerDialogVisible = true
          
       },
        editRoleMenu(roleId){
        this.menu = []
        this.menuCheck=[]
          this.centerDialogRoleVisible = true
          this.postRequest('/menu/load',[]).then(resp => {
              if(resp.data){
                  this.menuList = resp.data
              }
          })
         this.addRoleMenu.roleId=roleId
         this.postRequest('/menu/menu_by_role_id', this.addRoleMenu).then(resp => {
              if(resp.data){
                  var menus = resp.data
                  menus.forEach(element => {
                      this.menu.push(element.menuId);
                      element.chridens.forEach(el =>{
                          this.menuCheck.push(el.menuId)
                      })
                  });
              }
          })
         this.roleId = roleId
          
       },
       handleSizeChange(val) {
          this.params.pageSize = val;
          this.loadAdminList();
       },
       handleCurrentChange(val) {
          this.params.pageNum = val;
          this.loadAdminList();
       },
       addAdmin(){
           this.centerDialogVisible = true
           this.title = '添加管理员';

       },
       addMenuFunct(){
           this.addMenu = [];
           var array = this.$refs.tree.getCheckedNodes();
           array.forEach(element => {
               this.addMenu.push(element.menuId)
           })
           this.addRoleMenu.roleId = this.roleId;
           this.addRoleMenu.menuIds = JSON.stringify(this.addMenu);
           this.postRequest('/role/bind_menu',this.addRoleMenu).then(resp => {
               if(resp){
                   this.centerDialogRoleVisible = false
                      Message.success({message: resp.msg})
               }
           })
           
       },
       addAdminFunct(){
           this.postRequest('/role/add', this.form).then(resp => {
                if (resp) {
                    this.centerDialogVisible = false
                    this.loadAdminList()
                   // Message.success({message: resp.msg})
                }
            })
       },
       onSubmit() {
        console.log('submit!');
      },
       loadAdminList(){
             this.postRequest('/role/list', this.params).then(resp => {
                this.loading = false;
                if (resp) {
                    this.pageNum = resp.data.pageNum
                    this.totalPage = resp.data.totalPage
                    this.pageSize=resp.data.pageSize
                    this.total = resp.data.total
                    this.roles = resp.data.list
                }
            })
       }     
    },
 mounted(){
     this.loadAdminList();
 }
}
</script>
<style>
    .block{
        margin-top: 1%;
        margin-right: 1%;
    }
    .infinite-list{
        border: rgba(92, 48, 145, 0.04);
        margin-top: 1%;
        margin-left: 10%;
    }
    .alal{
      background-image: url(../../assets/1231232.jpg);
        
    }
    .all{
       box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
   
    .h1{
        font-style: initial;
        font-size: 50px;
    }
    .button{
        margin-top: 1%;
        margin-left: 20%;
    }
</style>